import { useState, useEffect } from 'react';
import './Nav.css';
import Button from '../../components/Button/Button';

const Nav = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200); // Default check

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const offset = isMobile ? 450 : 0;
    const offset2 = isMobile ? 750 : 0;
    const offset3 = isMobile ? 1900 : 0;

    const reload = () => { 
        window.location.reload();
    }
    const homeClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const achievementsClick = () => {
        window.scrollTo({ top: 500 + offset, behavior: 'smooth' });
    };

    const projectsClick = () => {
        window.scrollTo({ top: 1120 + offset2, behavior: 'smooth' });
    };

    const certificatesClick = () => {
        window.scrollTo({ top: 1720 + offset3, behavior: 'smooth' });
    };

    const contactsClick = () => {
        window.scrollTo({ top: 6020, behavior: 'smooth' });
    };

    const resume = () => {
        window.open(props.alldata[0].resume_link, '_blank');
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <Button onClick={reload}>Vishwash Soni</Button>

            {/* Hamburger Menu */}
            <div className="hamburger" onClick={toggleMenu}>
                <div></div>
                <div></div>
                <div></div>
            </div>

            {/* Navigation Menu */}
            <div className={`menu ${isOpen ? 'open' : ''}`}>
                <Button onClick={homeClick}>Home</Button>
                <Button onClick={achievementsClick}>Achievements</Button>
                <Button onClick={projectsClick}>Projects</Button>
                <Button onClick={certificatesClick}>Certificates</Button>
                <Button onClick={contactsClick}>Contacts</Button>
                <Button onClick={resume}>Resume</Button>
            </div>
        </nav>
    );
};

export default Nav;
